import '../style/quiz.scss';

// On window load stuff
window.addEventListener('load', () => {
    const questions: NodeListOf<HTMLElement> = document.querySelectorAll('.question-wrapper')
    if (questions.length > 0) {
        questions[0].classList.remove('hidden')
        questions[0].classList.add('slide-in')
    }

    const buttons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.answer-btn');
    buttons.forEach(button => {
        button.addEventListener('click', (e) => {
            const btn = <HTMLButtonElement>e.currentTarget;
            const questionNumber: string = btn.getAttribute('data-question') ?? '0'
            const answer: string = btn.getAttribute('data-value') ?? ''
            handleClick(parseInt(questionNumber), answer, questions.length)
        })
    })
    showSharePanel()
    hideSharePanel()

    const backButtons: NodeListOf<HTMLButtonElement> = document.querySelectorAll('.back-btn');
    backButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            const btn = <HTMLButtonElement>e.currentTarget;
            const activeQuestionNr: string = btn.getAttribute('data-from-question') ?? '0'
            handleGoBack(parseInt(activeQuestionNr), questions.length)
        })
    })
});

const handleGoBack = (activeQuestionNr: number, questionsCount: number) => {
    hideQuestion(activeQuestionNr, questionsCount, true)
    showQuestion(activeQuestionNr - 1, questionsCount, true)
}

const handleClick = (questionNumber: number, value: string, questionsCount: number) => {
    if (questionNumber !== 0) {
        if (handleQuestionInput(questionNumber, value)) {
            hideQuestion(questionNumber, questionsCount)
            showQuestion(questionNumber + 1, questionsCount)
            if (questionNumber === questionsCount) {
                hideQuestion(questionNumber, questionsCount)
                // showLoadingScreen()
                // setTimeout(function () {
                    submitQuizForm()
                // }, Math.floor((Math.random() * 5 + 1) * 1000))
            }
        }
    }
}

const showLoadingScreen = () => {
    const loadingScreen: HTMLElement | null = document.querySelector('#loadingscreen')
    if (loadingScreen) {
        setTimeout(() => {
            loadingScreen.classList.add('flex', 'fade-in')
            loadingScreen.classList.remove('hidden')
        }, 500)
    }
}

const showSharePanel = () => {
    const shareForm: HTMLElement | null = document.querySelector('#shareform')
    shareForm?.classList.toggle('hidden')
}

const hideSharePanel = () => {
    const shareForm: HTMLElement | null = document.querySelector('#shareform')
    shareForm?.classList.toggle('hidden')
}

const hideQuestion = (questionNumber: number, questionsCount: number, backwards: boolean = false) => {
    if (questionNumber <= questionsCount) {
        const questionWrapper: HTMLElement | null = document.getElementById('question_' + questionNumber)
        if (questionWrapper) {
            // questionWrapper.classList.remove('slide-in')
            // questionWrapper.classList.remove('slide-in-backwards')
            // backwards ? questionWrapper.classList.add('slide-out-backwards') : questionWrapper.classList.add('slide-out')
            // setTimeout(() => {
                 questionWrapper.classList.add('hidden')
            //     backwards ? questionWrapper.classList.remove('slide-out-backwards') : questionWrapper.classList.remove('slide-out')
            // }, 500)
        }
    }
}

const showQuestion = (questionNumber: number, questionsCount: number, backwards: boolean = false) => {

    let body = document.querySelector('body') as HTMLElement;
    let animationWrapper = document.querySelector('.bg_animation') as HTMLElement;
    let progressBar = document.querySelector('.quiz-progress__bar') as HTMLElement;

    // Calculate the percentage of completed questions
    let progressPercentage = (questionNumber / (questionsCount + 1)) * 100;

    progressBar.style.width = progressPercentage + '%';

    // Remove classes from animation wrapper and body
    let allClasses = ["kontroll", "medieteknikk", "mediedesign", "it-drift", "byggdrifter", "sikkerhetsfaget",
        "service-og-administrasjon", "dataelektroniker", "it-utvikling", "innholdsproduksjon"];
    allClasses.forEach(className => animationWrapper.classList.remove(className));
    allClasses.forEach(className => body.classList.remove(className));

    //Get question element
    let questionElement = document.getElementById("question_" + questionNumber) as HTMLElement;

    // Toggle class for background animation on questions
    animationWrapper.classList.toggle('reverse');

    if (questionNumber <= questionsCount) {
        // Add question type as class to animation wrapper
        animationWrapper.classList.add(questionElement.dataset.questionType || "");
        body.classList.add(questionElement.dataset.questionType || "");

        const questionWrapper: HTMLElement | null = document.getElementById('question_' + questionNumber)
        if (questionWrapper) {
            // setTimeout(() => {
            //     backwards ? questionWrapper.classList.add('slide-in-backwards') : questionWrapper.classList.add('slide-in')
                questionWrapper.classList.remove('hidden')
            // }, 500)
        }
    }
}

const submitQuizForm = () => {
    const form = <HTMLFormElement>document.getElementById('quiz-form')
    form.submit()

    // Matomo-shit that gets pushed out in global scope for async handling.
    // I like it just as much as you do, probably.....
    // @ts-ignore
    _paq.push(['FormAnalytics::trackFormSubmit', form]);
}

const handleQuestionInput = (questionNumber: number, answer: string): boolean => {
    const questionType = <HTMLInputElement>document.getElementById(`question_${questionNumber}_type`)

    if (!questionType?.value) {
        console.error('Unknown value')
        return false
    }

    const questionIdElement = <HTMLInputElement | null>document.getElementById(`question_${questionNumber}_id`)
    const matomoAnswerInput = <HTMLInputElement | null>document.getElementById(`${questionIdElement?.value}-matomo-answer`)
    if (matomoAnswerInput) {
        // Hackety-hack-hack for Matomo.
        matomoAnswerInput.focus()
        matomoAnswerInput.value = answer
        matomoAnswerInput.blur()
    }

    if (questionType.value == 'graded') {
        return true
    } else if (questionType.value == 'yes/no' || questionType.value == 'control question') {
        const checkbox = <HTMLInputElement>document.getElementById(`id_${questionIdElement?.value}-answer`)
        const answerBool: boolean = answer === 'Yes'
        if (checkbox) checkbox.checked = answerBool
        return true
    } else {
        console.error('Unknown question type')
        return false;
    }
}
